import { render, staticRenderFns } from "./createContribution.vue?vue&type=template&id=465f6732&scoped=true&"
import script from "./createContribution.vue?vue&type=script&lang=ts&"
export * from "./createContribution.vue?vue&type=script&lang=ts&"
import style0 from "./createContribution.vue?vue&type=style&index=0&id=465f6732&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465f6732",
  null
  
)

export default component.exports